import { render, staticRenderFns } from "./restrictData.vue?vue&type=template&id=0f27d128&"
import script from "./restrictData.vue?vue&type=script&lang=js&"
export * from "./restrictData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports